<template>
  <div v-show="commonCssLoaded" theme-main-layout :class="{'home-path': isHome, 'has-no-default-layout': $route.query.hasNoDefaultLayout}">
    <div v-if="getEnv() === 'local'" class="env-tag">
      {{ getEnv() }}
    </div>
    <div v-if="updatingMsg" class="version-update-guide" v-html="updatingMsg" />
    <div v-else-if="configs && theme" class="theme-container">
      <div id="theme-header" />
      <div id="theme-leftside" />
      <div id="theme-content">
        <nuxt />
        <div class="clear" />
      </div>
      <div id="theme-rightside" />
      <div id="theme-footer" />
    </div>
    <login-modal ref="loginModal" />
    <revised-stipulation-modal />

    <div id="css-loading-checking-element" />
    <change-password-modal ref="changePasswordModal" :user-id="userIdInserted" />
    <choose-user-modal ref="chooseUserModal" :user-id="userIdInsertedForChoose" :user-pwd="userPwdInsertedForChoose" :action="chooseUserAction" />
    <convert-to-paid-user-modal ref="convertToPaidUserModal" />
    <secession-modal ref="secessionModal" />
    <cancel-secession-modal ref="cancelSecessionModal" />
    <user-activation-modal ref="userActivationModal" :user="activateTargetUser" />
    <user-device-deletion-modal ref="userDeviceDeletionModal" :user="userDeviceDeletionTargetUser" />
    <div v-for="(popup, popupIndex) in showPopups" :key="popupIndex" class="popup-container">
      <div class="popup-box">
        <div class="popup-title" v-html="popup.title" />
        <div class="popup-contents" v-html="popup.cn" />
        <div class="popup-controls">
          <div class="popup-controls-inner">
            <div class="custom-checkbox">
              <input :id="'never-see-again-' + popup.id" v-model="neverSeeAgain[popup.id]" type="checkbox" class="custom-control-input never-see-again-checkbox">
              <label :for="'never-see-again-' + popup.id" class="custom-control-label never-see-again-checkbox-label">{{ $t('popup.button.never_see_again') }}</label>
            </div>
            <button class="btn-sm btn" @click="closePopup(popupIndex, popup.id, !!neverSeeAgain[popup.id])">
              {{ $t('popup.button.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginModal from '~/components/modals/LoginModal'
import RevisedStipulationModal from '~/components/modals/RevisedStipulationModal'
import NotFoundPage from '~/pages/error/404'
import ChangePasswordModal from '~/components/modals/ChangePasswordModal'
import ChooseUserModal from '../components/modals/ChooseUserModal'
import ConvertToPaidUserModal from '../components/modals/ConvertToPaidUserModal'
import SecessionModal from '../components/modals/SecessionModal'
import CancelSecessionModal from '../components/modals/CancelSecessionModal'
import UserActivationModal from '../components/modals/UserActivationModal'
import UserDeviceDeletionModal from '../components/modals/UserDeviceDeletionModal'
let bodyClass

export default {
  components: {
    SecessionModal,
    CancelSecessionModal,
    ConvertToPaidUserModal,
    ChooseUserModal,
    LoginModal,
    RevisedStipulationModal,
    ChangePasswordModal,
    UserActivationModal,
    UserDeviceDeletionModal
  },
  data: function() {
    return {
      updatingMsg: '',
      isDefaultLayout: true,
      commonCssLoaded: false,
      userIdInserted: '',
      userIdInsertedForChoose: '',
      userPwdInsertedForChoose: '',
      chooseUserAction: '',
      theme: '',
      neverSeeAgain: {},
      url: '',
      html: '',
      isHome: false,
      showPopups: [],
      activateTargetUser: undefined,
      userDeviceDeletionTargetUser: undefined,
      currentAndroidVer: '3.0.16',
      currentIosVer: '2.0.7',
      offlineMeetingInProgress: undefined
    }
  },
  computed: {
    locales() {
      return this.$store.state.locales
    }
  },
  watch: {
    locales: function(newVal) {
      this.trySetTitle()
      this.$forceUpdate()
      this.setWebsiteSubtitle()
    },
    configs: function(newVal, oldVal) {
      this.trySetTitle()
      this.$forceUpdate()
      if (!this.theme) {
        this.theme = this.configs.theme
        this.url = '/'
      }
      this.setMainColor()
      this.setWebsiteSubtitle()

      this.setFavicon()
    },
    url: function(newVal, oldVal) {
      this.startLoad()
    },
    '$route.path': {
      handler: function(newVal) {
        if (newVal === '/' || newVal === '') {
          this.isHome = true
        } else {
          this.isHome = false
        }
        $(this.$el)
          .find('#theme-content')
          .css('opacity', 0)
        $('body').attr('path', newVal)

        const link = newVal
        if (
          link !== '/login' &&
          link !== '/registration' &&
          link !== '/registration_stipulation' &&
          link !== '/registration_complete' &&
          link !== '/registration_detail'
        ) {
          this.checkLogin()
        }
      },
      immediate: true
    },
    theme: function(newVal, oldVal) {
      const head = document.getElementsByTagName('head')[0]
      let v = ''
      if (localStorage && localStorage.buildTime) {
        v = '?v=' + localStorage.buildTime
      }
      const url = '/themes/' + newVal + '/pack/css/common.css?v=' + v
      let link = document.createElement('link')

      link.as = 'style'
      link.rel = 'preload'
      link.href = url
      head.appendChild(link)

      link = document.createElement('link')

      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href = url
      link.onload = () => {
        this.commonCssLoaded = true
      }
      head.appendChild(link)
      this.startLoad()
    },
    menus: {
      handler(newVal, oldVal) {
        this.updateRoutes(newVal)
        if (!this.templates || this.templates.length === 0) {
          return
        }
        for (let i = 0; i < this.templates.length; i++) {
          if (this.templates[i].name === 'menu-item') {
            const template = this.templates[i]
            template.redraw = true
            let data = []
            for (let j = 0; j < this.menus.length; j++) {
              const menu = this.menus[j]
              let add = false
              if (template.options && template.options.menuLocationCode) {
                if (menu.menuDsplyLcs && menu.menuDsplyLcs.length > 0) {
                  for (let k = 0; k < menu.menuDsplyLcs.length; k++) {
                    const menuLcCode = menu.menuDsplyLcs[k].menuLcCode
                    if (template.options.menuLocationCode === menuLcCode) {
                      add = true
                    }
                  }
                }
              }
              if (template.options && template.options.rootMenu) {
                if (menu.menu === template.options.rootMenu) {
                  data = menu.children
                  break
                }
              }
              if (add) {
                data.push(menu)
              }
            }
            this.drawTemplateWithData(template, data)
          }
        }
        if (window.onRightMenuChanged) {
          this.$nextTick(() => {
            window.onRightMenuChanged()
          })
        }
      },
      deep: true,
      immediate: true
    },
    loggedInUser: function(newVal, oldVal) {
      this.$eventHub.$emit('logged-in-user-changed', newVal)
      if (!oldVal && newVal) {
        if (this.configs) {
          this.checkPasswordExpiration()
        }
        this.loadResetAlarms()
        if (window.app && window.app.setAuthorization) {
          window.app.setAuthorization(this.$auth.$storage._state['_token.jwt'])
        }
      }
      if (newVal) {
        if (
          window.app &&
          window.app.getPushToken &&
          window.app.getPushToken()
        ) {
          this.onPushTokenLoaded(window.app.getPushToken())
        }
      } else {
        if (window.app && window.app.clearAllAlarms) {
          window.app.clearAllAlarms()
        }
        if (window.app && window.app.setAuthorization) {
          window.app.setAuthorization(null)
        }
      }
    }
  },
  head() {
    return {
      bodyAttrs: {
        class: bodyClass
      }
    }
  },
  created: function() {
    window.$t = this.$t
    window.openLink = this.openLink
    window._checkBuildTime = this.checkBuildTime
    window._onResume = () => {
      window._paused = false
      this.checkBuildTime()
    }
    window._onPause = () => {
      window._paused = true
    }
    const errFunc = console.error
    console.error = (...args) => {
      errFunc(...args)

      let msg = ''
      try {
        for (const arg of args) {
          if (arg instanceof Error) {
            msg = arg.message
            if (arg.stack) {
              msg += '\n' + arg.stack
            }
            break
          } else if (typeof arg === 'object') {
            if (arg && arg.data && arg.data.message) {
              msg = arg.data.message
              break
            } else if (arg && arg.message) {
              msg = arg.message
              break
            } else {
              msg = JSON.stringify(arg)
            }
          } else if (typeof arg === 'string') {
            msg = arg
            break
          }
        }
      } catch (e) {
        msg = 'Error parsing console.error arguments'
      }

      if (!msg || msg === '{}' || msg === '[]' || msg === '[object Object]') {
        msg = 'Unrecognized error: ' + JSON.stringify(args)
      }
      msg += '(Ver. ' + window.getAppVersion() + ') '
      msg += localStorage.buildTime
      const params = {
        msg: msg,
        args: args,
        stackTrace: window.getStackTrace(),
        userAgent: navigator.userAgent,
        path: this.$route.fullPath,
        userId: this.loggedInUser ? this.loggedInUser.userId : '',
        userInfo: {
          userId: this.loggedInUser ? this.loggedInUser.userId : '',
          nm: this.loggedInUser ? this.loggedInUser.nm : ''
        }
      }
      this.$axios.$post('/error/public/error', params, {
        no_loading: true,
        processing: false
      })
    }
    if (!this.checkBuildTime()) {
      return false
    }
    let windowWidth = window.innerWidth
    if (!windowWidth) {
      windowWidth = document.body.clientWidth
    }
    if (windowWidth >= 768) {
      bodyClass = 'app header-fixed sidebar-fixed aside-menu-fixed sidebar-show'
    } else {
      bodyClass = 'app header-fixed sidebar-fixed aside-menu-fixed'
    }
    window._globalVueParams = {
      $router: this.$router,
      $i18n: this.$i18n,
      $axios: this.$axios,
      $auth: this.$auth,
      $store: this.$store,
      $toast: this.$toast
    }
    if (window._loadedPushToken) {
      this.onPushTokenLoaded(window._loadedPushToken)
    }
    window._onPushTokenLoaded = this.onPushTokenLoaded
    window._onShaking = this.onShaking
  },
  mounted() {
    // if (window.device && window.device.enableCapture) {
    //   if (process && process.env && process.env.env !== 'production') {
    //     window.device.enableCapture()
    //   }
    // }
    if (window.device && window.device.enableCapture) {
      window.device.enableCapture()
    }
    const isMobile = !!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
    if (!isMobile) {
      alert('모바일로만 접근이 가능합니다.')
      console.error('모바일로만 접근이 가능합니다. ' + navigator.userAgent)
      return
    }
    if (
      !window.device &&
      navigator.userAgent.indexOf('AppTest') < 0 &&
      this.$route.path.indexOf('/offline_meeting_ticket') < 0 &&
      this.$route.path.indexOf('/delete_my_data') < 0 &&
      this.$route.path.indexOf('/calc') < 0
    ) {
      console.error(
        'U MAP 신규 앱이 설치되지 않은 경우 설치가 필요합니다. 마켓으로 이동하시겠습니까?'
      )
      if (
        confirm(
          'U MAP 신규 앱이 설치되지 않은 경우 설치가 필요합니다.\n마켓으로 이동하시겠습니까?'
        )
      ) {
        window.location.replace('market://details?id=kr.unistars')
        setTimeout(() => {
          window.location.href = 'market://details?id=kr.unistars'
          setTimeout(() => {
            window.location.href =
              'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=kr.unistars'
          }, 500)
        }, 500)
      }
      return
    }
    if (!this.checkVersion()) {
      return false
    }
    if (window.app && window.app.onAllPartsLoaded) {
      setTimeout(function() {
        window.app.onAllPartsLoaded()
      }, 4000)
    }
    this.offlineMeetingInProgressTimer = setInterval(
      this.getOfflineMeetingInProgress,
      5000
    )
    this.getOfflineMeetingInProgress()
    window._loadResetAlarms = this.loadResetAlarms
    window.history.scrollRestoration = 'auto'
    if (this.$router) {
      this.$router.beforeEach((to, from, next) => {
        if (
          from.path !== '/reset_manager' ||
          to.path !== '/reset_manager' ||
          from.query.mode !== to.query.mode
        ) {
          if (window._processingDataCount && window._processingDataCount > 0) {
            if (confirm(this.$t('goods.confirm.cancel_work'))) {
              window._processingDataCount = 0
            } else {
              return
            }
          }
        }
        if (from.path !== '/login' && to.path === '/login') {
          if (!to.query.referer) {
            let path = from.path
            if (from.query && Object.keys(from.query).length > 0) {
              path += '?'
              for (const key in from.query) {
                path += key + '=' + from.query[key] + '&'
              }
            }
            to.query.referer = path
            next({ path: to.path, query: to.query })
          } else {
            next()
          }
        } else if (
          from.path !== '/registration' &&
          from.path !== '/registration_detail' &&
          to.path === '/registration_complete'
        ) {
          next('/login')
        } else if (
          from.path !== '/registration_stipulation' &&
          from.path !== '/registration_detail' &&
          to.path === '/registration'
        ) {
          next('/registration_stipulation')
        } else if (to.path === '/logout') {
          this.$auth.logout().then(response => {
            next('/')
          })
        } else if (
          from.path !== '/reset_manager' &&
          to.path === '/reset_manager' &&
          to.query.submenu === 'reset_ing' &&
          (to.query.mode === 'create' ||
            to.query.mode === 'update' ||
            to.query.mode === 'transfer')
        ) {
          next({
            path: '/reset_manager',
            query: { submenu: 'reset_ing', mode: 'calendar' }
          })
        } else {
          this.$router.previousPath = from.path
          this.$router.previousQuery = from.query
          next()
        }
      })
    }
    this.$eventHub.$on('onSessionExpired', this.onSessionExpired)
    this.$eventHub.$on('onBeginRequest', this.onBeginRequest)
    this.$eventHub.$on('onEndRequest', this.onEndRequest)
    this.$eventHub.$on('refreshAll', this.refreshAll)
    this.$eventHub.$on('content-loaded', this.onContentLoaded)
    this.$eventHub.$on('showChangePasswordModal', this.showChangePasswordModal)
    this.$eventHub.$on('showChooseUserModal', this.showChooseUserModal)
    this.$eventHub.$on('showSecessionModal', this.showSecessionModal)
    this.$eventHub.$on('showUserActivationModal', this.showUserActivationModal)
    this.$eventHub.$on(
      'showUserDeviceDeletionModal',
      this.showUserDeviceDeletionModal
    )
    this.$eventHub.$on(
      'showCancelSecessionModal',
      this.showCancelSecessionModal
    )
    this.$eventHub.$on(
      'showConvertToPaidUserModal',
      this.showConvertToPaidUserModal
    )

    if (!this.loggedInUser) {
      this.loadDefaultMenus()
    } else {
      this.loadResetAlarms()
    }

    if (this.$route.query.msg) {
      if (
        !this.$route.query.resultCode ||
        this.$route.query.resultCode === 'success'
      ) {
        this.toastInfo(this.$route.query.msg)
      } else {
        this.toastError(this.$route.query.msg)
      }
    }
    this.loadConfigs()
    this.trySetTitle()
    window.showI18nCode = this.showI18nCode

    this.setMainColor()
    this.setWebsiteSubtitle()
    if (this.$route.path === '/' || this.$route.path === '') {
      this.isHome = true
    } else {
      this.isHome = false
    }
    if (this.configs) {
      this.setFavicon()
    }
    this.startLoad()
    this.checkLogin()
    // 티켓이 아니면..
    if (
      this.$route.path.indexOf('/offline_meeting_ticket') < 0 &&
      this.$route.path.indexOf('/calc') < 0
    ) {
      // 팝업을 조회한다.
      this.loadPopup()
    }
    if (window.app && window.app.onPageLoaded) {
      window.app.onPageLoaded()
    }
  },
  beforeDestroy() {
    if (this.offlineMeetingInProgressTimer) {
      clearInterval(this.offlineMeetingInProgressTimer)
    }
    this.$eventHub.$off('onSessionExpired', this.onSessionExpired)
    this.$eventHub.$off('onBeginRequest', this.onBeginRequest)
    this.$eventHub.$off('onEndRequest', this.onEndRequest)
    this.$eventHub.$off('refreshAll', this.refreshAll)
    this.$eventHub.$off('content-loaded', this.onContentLoaded)
    this.$eventHub.$off('showChangePasswordModal', this.showChangePasswordModal)
    this.$eventHub.$off('showChooseUserModal', this.showChooseUserModal)
    this.$eventHub.$off('showSecessionModal', this.showSecessionModal)
    this.$eventHub.$off('showUserActivationModal', this.showUserActivationModal)
    this.$eventHub.$off(
      'showUserDeviceDeletionModal',
      this.showUserDeviceDeletionModal
    )
    this.$eventHub.$off(
      'showCancelSecessionModal',
      this.showCancelSecessionModal
    )
    this.$eventHub.$off(
      'showConvertToPaidUserModal',
      this.showConvertToPaidUserModal
    )
  },
  methods: {
    onShaking() {
      if (this.loggedInUser && this.offlineMeetingInProgress) {
        this.openLink('/offline_meeting_ticket')
      }
    },
    getOfflineMeetingInProgress() {
      if (!this.loggedInUser) {
        return
      }
      this.$axios
        .$get('/offline_meeting/getMyOfflineMeetingAttendancePolling')
        .then(response => {
          if (response.resultCode === 'success') {
            this.offlineMeetingInProgress = response.data
          } else {
            this.offlineMeetingInProgress = undefined
          }
        })
        .catch(() => {
          this.offlineMeetingInProgress = undefined
        })
    },
    checkBuildTime() {
      let buildTime
      $.ajax({
        type: 'GET',
        url: '/buildTime.txt?ts=' + Date.now(),
        async: false,
        success: function(data) {
          buildTime = data
        }
      })
      if (buildTime && localStorage.buildTime !== buildTime) {
        localStorage.buildTime = buildTime
        this.clearCache()
        return false
      }
      return true
    },
    checkVersion() {
      console.log('Installed version : ' + window.getAppVersion())
      console.log('Recent ios version : ' + this.currentIosVer)
      console.log('Recent android version : ' + this.currentAndroidVer)
      console.log('This OS type : ' + window.getOsType())
      if (
        ((window.getOsType() === 'os_type.android' &&
          window.getAppVersion() !== this.currentAndroidVer) ||
          (window.getOsType() === 'os_type.ios' &&
            window.getAppVersion() !== this.currentIosVer)) &&
        window.getAppVersion() !== 'Unknown app version'
      ) {
        console.log('You have installed not latest version.')
        const vers = window.getAppVersion().split('.')
        const major = parseInt(vers[0])
        const minor = parseInt(vers[1])
        const extra = parseInt(vers[2])
        let currentVer
        if (window.getOsType() === 'os_type.ios') {
          currentVer = this.currentIosVer
        } else {
          currentVer = this.currentAndroidVer
        }
        const currentVers = currentVer.split('.')
        const currentMajor = parseInt(currentVers[0])
        const currentMinor = parseInt(currentVers[1])
        const currentExtra = parseInt(currentVers[2])
        let updatedNeeded = false
        if (major < currentMajor) {
          updatedNeeded = true
        } else if (major === currentMajor && minor < currentMinor) {
          updatedNeeded = true
        } else if (
          major === currentMajor &&
          minor === currentMinor &&
          extra < currentExtra
        ) {
          updatedNeeded = true
        }
        if (updatedNeeded) {
          this.clearCache()
          this.$eventHub.$emit('content-loaded')
          this.updatingMsg =
            '최신버전이 아닙니다. 스토어에서 업데이트를 받아주세요.<br/>현재 설치된 앱 버전 : ' +
            window.getAppVersion() +
            '<br />출시된 최신 버전 : ' +
            currentVer
          alert(
            '최신버전이 아닙니다. 스토어에서 업데이트를 받아주세요.\n현재 설치된 앱 버전 : ' +
              window.getAppVersion() +
              '\n출시된 최신 버전 : ' +
              currentVer
          )
          if (window.app && window.app.openBrowser) {
            if (window.getOsType() === 'os_type.ios') {
              window.app.openBrowser(
                'https://itunes.apple.com/us/app/keynote/id6444147949?mt=8'
              )
            } else {
              window.app.openBrowser('market://details?id=kr.unistars')
            }
          }
          return false
        }
      }
      return true
    },
    onPushTokenLoaded(token) {
      if (!this.loggedInUser) {
        return
      }
      window._pushToken = token
      window._pushToken = token
      console.log('Token : ' + token)
      this.$axios.post(
        '/notification/setToken',
        {},
        {
          no_loading: true
        }
      )
    },
    confirmPushNotification(id) {
      this.$axios.put(
        '/notification/read',
        { id: id },
        {
          no_loading: true
        }
      )
    },
    closePopup(popupIndex, id, neverSeeAgain) {
      this.showPopups.splice(popupIndex, 1)
      this.$forceUpdate()
      if (neverSeeAgain) {
        if (!localStorage.dontShowPopupIds) {
          localStorage.dontShowPopupIds = '[]'
        }
        const dontShowPopupIds = JSON.parse(localStorage.dontShowPopupIds)
        dontShowPopupIds.push(id)
        localStorage.dontShowPopupIds = JSON.stringify(dontShowPopupIds)
      }
    },
    loadResetAlarms() {
      const now = new Date()
      const param = {
        year: now.getFullYear(),
        month: now.getMonth()
      }
      let beginDt = param.year + '/'
      if (param.month + 1 < 10) {
        beginDt += '0'
      }
      beginDt = beginDt + (param.month + 1) + '/01'

      if (!this.resetListRequestId) {
        this.resetListRequestId = 0
      }
      this.resetListRequestId++
      const endTime = new Date()
      endTime.setFullYear(param.year)
      endTime.setMonth(param.month + 2)
      endTime.setDate(0)

      let endDt = endTime.getFullYear() + '/'
      if (endTime.getMonth() + 1 < 10) {
        endDt += '0'
      }
      endDt = endDt + (endTime.getMonth() + 1) + '/31'

      const url =
        '/reset/myresets?beginDt=' +
        encodeURIComponent(beginDt) +
        '&endDt=' +
        encodeURIComponent(endDt)
      this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          if (response.data) {
            this.resets = response.data
          } else {
            this.resets = []
          }
          this.setResetAlarms(this.resets)
        }
      })
    },
    checkPasswordExpiration() {
      this.$nextTick(() => {
        if (this.loggedInUser && this.loggedInUser.passwordExpired) {
          if (this.configs.password_expiration_policy === '2') {
            this.$refs.changePasswordModal.showModal('modalRef')
          } else if (this.configs.password_expiration_policy === '3') {
            this.$toast.error(this.$t('validation.message.expired_password'))
          }
        }
      })
    },
    showChooseUserModal(params) {
      this.userIdInsertedForChoose = params.userId
      this.userPwdInsertedForChoose = params.userPwd
      this.chooseUserAction = params.action
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.chooseUserModal.showModalAndLoad()
      })
    },
    showSecessionModal() {
      this.$refs.secessionModal.showModal('modalRef')
    },
    showUserActivationModal(param) {
      this.activateTargetUser = param
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.userActivationModal.showModal('modalRef')
      })
    },
    showUserDeviceDeletionModal(param) {
      this.userDeviceDeletionTargetUser = param
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.userDeviceDeletionModal.showModal('modalRef')
      })
    },
    showCancelSecessionModal() {
      this.$refs.cancelSecessionModal.showModal('modalRef')
    },
    showConvertToPaidUserModal(skipPay) {
      this.$refs.convertToPaidUserModal.skipPay = skipPay
      this.$refs.convertToPaidUserModal.showModal('modalRef')
    },
    showChangePasswordModal(params) {
      this.userIdInserted = params.userId
      this.$refs.changePasswordModal.showModal('modalRef')
    },
    onContentLoaded() {
      this.$eventHub.$emit('hideInitLoading')
      $('#theme-content').css('opacity', 1)
      if (window._themeContentHeightBefore) {
        const themeContentHeightBefore = window._themeContentHeightBefore
        setTimeout(() => {
          $('#theme-content').css('height', 'auto')
          const themeContentHeightAfter = $(this.$el)
            .find('#theme-content')
            .height()
          $('#theme-content').height(themeContentHeightBefore)
          $('#theme-content').height(themeContentHeightAfter)
          setTimeout(() => {
            $('#theme-content').css('height', 'auto')
          }, 400)
        }, 400)
        delete window._themeContentHeightBefore
      }
    },
    startLoad() {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.startLoad()
        }, 50)
        return
      }
      this.loadHtml()
    },
    setFavicon() {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = '/img/favicons/favicon-unistars.ico'

      document.getElementsByTagName('head')[0].appendChild(link)
    },
    setMainColor() {
      if (!this.configs || !this.configs.main_color) {
        return
      }
      window._mainColor = this.configs.main_color
      const self = this
      $('[set-background-main-color]').each(function() {
        $(this).removeAttr('set-bacground-main-color')
        $(this).css('background-color', self.configs.main_color)
      })
    },
    setWebsiteSubtitle() {
      if (!this.configs || !this.configs.website_subtitle) {
        return
      }
      window._websiteSubtitle = this.$t(this.configs.website_subtitle)
      $('.website-subtitle').html(window._websiteSubtitle)
    },
    loadPopup() {
      if (!localStorage.dontShowPopupIds) {
        localStorage.dontShowPopupIds = '[]'
      }
      const dontShowPopupIds = JSON.parse(localStorage.dontShowPopupIds)
      this.$axios
        .$post(
          '/bbs/public/popups',
          {
            dontShowPopupIds: dontShowPopupIds
          },
          {
            no_loading: true
          }
        )
        .then(response => {
          if (response.resultCode === 'success') {
            const popups = response.data
            if (popups && popups.length > 0) {
              this.showPopups = []
              for (let i = 0; i < popups.length; i++) {
                const popup = popups[i]
                let skip = false
                for (let j = 0; j < dontShowPopupIds.length; j++) {
                  const dontShowPopupId = dontShowPopupIds[j]
                  if (popup.id === parseInt(dontShowPopupId)) {
                    skip = true
                    break
                  }
                }
                if (!skip) {
                  this.showPopups.push(popup)
                }
              }
              const self = this
              this.$nextTick(() => {
                $(this.$el)
                  .find('.popup-contents a')
                  .each(function() {
                    if (
                      $(this).attr('href') &&
                      $(this)
                        .attr('href')
                        .startsWith('open/')
                    ) {
                      const href = $(this)
                        .attr('href')
                        .substring(4)
                      $(this).removeAttr('href')
                      $(this).removeAttr('target')
                      $(this).click(function(e) {
                        self.openPopupLink(href, e)
                      })
                    }
                  })
              })
            }
          } else if (response.message) {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          } else {
            console.error('Cannot load popups.')
            this.$toast.error('Cannot load popups.')
          }
        })
    },
    openPopupLink(href, e) {
      if (!this.loggedInUser) {
        this.$toast.error(this.$t('common.notification.login_required'))
        return
      }
      this.showPopups = []
      this.$forceUpdate()
      this.openLink(href, e)
    },
    onConfigLoaded(configs) {
      this.$store.commit('SET_CONFIGS', configs)
      this.checkPasswordExpiration()
    },
    loadConfigs() {
      if (localStorage.getItem('savedConfigs')) {
        this.onConfigLoaded(JSON.parse(localStorage.getItem('savedConfigs')))
        console.log('Cached configs')
        return
      }
      this.$axios
        .$get('/setup/public/setup', {
          no_loading: true
        })
        .then(response => {
          if (response.resultCode === 'success') {
            const configs = {}
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].keyString === 'valueTypes') {
                configs[response.data[i].keyString] = JSON.parse(
                  response.data[i].value
                )
              } else {
                configs[response.data[i].keyString] = response.data[i].value
              }
            }
            localStorage.setItem('savedConfigs', JSON.stringify(configs))
            this.onConfigLoaded(configs)
          } else if (response.message) {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          } else {
            console.error('Cannot load configs.')
            this.$toast.error('Cannot load configs.')
          }
        })
    },
    loadDefaultMenus() {
      this.$axios
        .$get('/menu/public/defaultMenus', {
          no_loading: true
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$store.commit('SET_DEFAULT_MENUS', response.data.menus)
            this.$store.commit('SET_DEFAULT_AUTHORS', response.data.authors)
          } else if (response.message) {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          } else {
            console.error('Cannot load default menus.')
            this.$toast.error('Cannot load default menus.')
          }
        })
    },
    showI18nCode() {
      window._showI18nCode = !window._showI18nCode
      if (window._showI18nCode) {
        this.$toast.info('Showing string code mode on')
      } else {
        this.$toast.info('Showing string code mode off')
      }
      this.$eventHub.$emit('refreshStrings')
    },
    refreshAll() {
      this.translateText()
      this.$forceUpdate()
    },
    onSessionExpired(params) {
      if (params.toast) {
        this.$toast.info(this.$t('auth.error.session_expired'))
      }
    },
    onBeginRequest() {},
    onEndRequest(config) {},
    trySetTitle() {
      if (this.locales.length > 0 && this.configs) {
        $(document).attr(
          'title',
          this.$t('common.title.website') +
            ' - ' +
            this.$t(this.configs.website_subtitle)
        )
      }
    },
    addMenus(menus, items) {
      if (!menus) {
        menus = []
      }
      if (!items || items.length === 0) {
        return menus
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        let exist = false
        for (let j = 0; j < menus.length; j++) {
          const menu = menus[j]
          if (menu.menu === item[0]) {
            exist = true
            break
          }
        }
        if (!exist) {
          menus.push({
            menu: item[0],
            module: {
              path: item[1]
            },
            parentPath: item[2] ? item[2] : '',
            depth1: item[3] ? item[3] : undefined
          })
        }
      }
      return menus
    },
    updateRoutes(menuParams, parentPath) {
      let menus = []
      if (menuParams) {
        menus = window.copyObject(menuParams)
      }
      if (!parentPath) {
        parentPath = ''
        menus = this.addMenus(menus, [
          ['stipulation', 'Stipulation'],
          ['profile', 'UserProfile', undefined, '/mypage'],
          ['logout', 'Logout'],
          ['registration', 'Registration'],
          ['registration_detail', 'RegistrationDetail'],
          ['login', 'Login'],
          ['goods', 'Goods'],
          ['study_lecture', 'StudyLecture', undefined, '/study'],
          ['study_view', 'StudyView', undefined, '/study'],
          ['study_test', 'StudyTest', undefined, '/study'],
          ['study_view', 'StudyView', undefined, '/study'],
          [
            'offline_meeting_detail',
            'OfflineMeetingDetail',
            undefined,
            '/offline_meeting'
          ],
          [
            'offline_meeting_history_detail',
            'OfflineMeetingHistoryDetail',
            undefined,
            '/offline_meeting'
          ],
          ['offline_meeting_ticket', 'OfflineMeetingTicket'],
          ['calc', 'SharedCalculation'],
          [
            'offline_meeting_request',
            'OfflineMeetingRequest',
            undefined,
            '/offline_meeting'
          ],
          [
            'offline_meeting_questionnaire',
            'OfflineMeetingQuestionnaire',
            undefined,
            '/offline_meeting'
          ],
          ['channel/:alias', 'Channel'],
          ['goods/player', 'Player'],
          ['goods/create', 'GoodsEditor'],
          ['goods/update', 'GoodsEditor'],
          ['search', 'Search'],
          ['category', 'Category'],
          ['registration_stipulation', 'RegistrationStipulation'],
          ['registration_complete', 'RegistrationComplete']
        ])
      }
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i]
        menu.parentPath = parentPath

        if (menu.module) {
          this.$router.addRoutes([
            {
              path: parentPath + '/' + menus[i].menu,
              component: require('~/components/modules/' +
                menu.module.path +
                '.vue').default,
              props: menu.options
            }
          ])
          if (!this.$router.totalRoutes) {
            this.$router.totalRoutes = []
          }
          this.$router.totalRoutes.push({
            path: parentPath + '/' + menus[i].menu,
            depth1: menus[i].depth1,
            component: require('~/components/modules/' +
              menu.module.path +
              '.vue').default,
            props: menu.options
          })
        }
        if (menu.children && menu.children.length > 0) {
          this.updateRoutes(menu.children, parentPath + '/' + menu.menu)
        }
      }
      this.$router.addRoutes([
        {
          path: '*',
          component: NotFoundPage
        }
      ])
    },
    loadHtml() {
      if (this.theme && this.url && !this.loadingHtmlStatus) {
        this.loadingHtmlStatus = 'loading'
        this.loadThemeScripts(() => {
          this.loadingHtmlStatus = 'scripts loaded'
          const baseUrl =
            location.protocol +
            '//' +
            location.host +
            '/themes/' +
            this.theme +
            '/pack'

          let parts = [
            {
              elem: '#theme-header',
              htmlFile: 'header'
            },
            {
              elem: '#theme-leftside',
              htmlFile: 'leftside'
            },
            {
              elem: '#theme-rightside',
              htmlFile: 'rightside'
            },
            {
              elem: '#theme-footer',
              htmlFile: 'footer'
            }
          ]
          if (this.$route.query.hasNoDefaultLayout) {
            parts = []
          }
          for (let i = 0; i < parts.length; i++) {
            const part = parts[i]
            this.loadPart(baseUrl, '/', part.elem, part.htmlFile)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.app-body .main {
  height: calc(100vh - 105px);
  padding: 10px;
}
.app-header {
  top: 0;
}
.theme-container {
  transition: all 0.2s ease-in-out;
}
.popup-title {
  color: #00f7d9;
  font-size: 1.05rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #360ea6;
  text-align: center;
  background-image: url(/img/unistars/background_bottom.png) !important;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  background-position-y: -3.5rem !important;
  height: 3.583333333333333rem;
  padding-top: 0;
  padding-bottom: 0;
}
.popup-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  padding: 4.666rem 2rem 3.7916rem;
}
.popup-box {
  background-color: white;
  position: absolute;
  width: calc(100vw - 4rem);
  height: calc(100vh - 8.4576rem);
  overflow-y: hidden;
  border-radius: 0.7rem;
  background-image: url(/img/unistars/deco_bottom.png) !important;
  background-repeat: no-repeat !important;
  background-size: 150% !important;
  background-position-x: 60%;
  background-position-y: 120% !important;
}
.popup-controls {
  display: flex;
  align-items: start;
  justify-content: center;
  padding: 0.416666666666667rem;
  padding-bottom: 1rem;
  height: 5.583333333333333rem;
}
.popup-controls .btn {
  width: auto;
  height: auto;
  padding: 0.5rem 2rem 0.3rem;
  margin: 0 0.5rem !important;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  color: white;
  background: #360ea6;
}
.popup-contents {
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100% - 10.166666666666666rem);
  padding: 0.833333333333333rem;
}
.popup-controls-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.popup-contents > * {
  max-width: 100%;
}
.never-see-again-checkbox-label {
  line-height: 2rem;
  margin-bottom: 0.5rem;
  color: #360ea6;
  font-size: 0.9rem;
  padding-left: 0.3rem;
}

.never-see-again-checkbox-label::before {
  border-radius: 0.7rem;
  width: 1.2916rem;
  height: 1.2916rem;
}
.never-see-again-checkbox-label::after {
  background-position: 0.4rem 0.8rem;
  background-size: 70%;
}
.version-update-guide {
  padding: 3rem;
  font-size: 1.3rem;
  text-align: center;
}
</style>
